module.exports = __webpack_public_path__ + "static/media/IMG-26.4bf3ced7.jpg";